import React from 'react'
import PropTypes from 'prop-types'
import i18n from 'i18next'
import Input from '#components/a/form/Input'
import SearchGlass from '#components/svg/icons/SearchGlass'
import SearchResult from './SearchResult'
import SearchResultList from './SearchResultList'
import FlyoutAnchor from '../Flyout/FlyoutAnchor'
import {FlyoutPivot} from '../Flyout/FlyoutPivot'
import {FlyoutPosition} from '../Flyout/FlyoutPosition'

export class Search extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      searchInput: '',
      searchTerm: null,
    }
  }

  handleInputChange = input => {
    if (input.trim().length >= 3) {
      this.setState({searchTerm: input, searchInput: input})
    } else {
      this.setState({searchTerm: null, searchInput: input})
    }
  }

  renderSearchResult = () => {
    const {searchTerm} = this.state
    const {type, list, clickHandler} = this.props
    if (type === 'wissensportal') {
      return (
        <SearchResultList
          list={list}
          searchTerm={searchTerm || ''}
          clickHandler={evt => {
            clickHandler(evt.target.textContent)
            this.setState({searchInput: '', searchTerm: null})
          }}
        />
      )
    }
    return <SearchResult searchParam={searchTerm || ''} onNavigationButtonClick={() => this.handleInputChange('')} />
  }

  render() {
    const {searchTerm, searchInput} = this.state
    const showResults = searchTerm !== null
    const flyoutProps = {
      flyoutPosition: FlyoutPosition.bottom,
      flyoutPivot: FlyoutPivot.start,
      openSync: showResults,
      flyoutContent: this.renderSearchResult(),
      flyoutDistance: 40,
      borderColor: '#343638',
      backgroundColor: 'transparent',
      showArrow: false,
      stayOpenOnAnchorClick: false,
    }
    const placeholder = this.props.type === 'wissensportal' ? 'wissensportal_search_default' : 'suche_placeholder_text'
    return (
      <div className="search" data-testid="search">
        <FlyoutAnchor {...flyoutProps}>
          <SearchGlass />
          <Input
            value={searchInput}
            className="search-input"
            placeholder={i18n.t(placeholder)}
            onChangeHandle={evt => this.handleInputChange(evt.target.value)}
            onClick={evt => this.handleInputChange(evt.target.value)}
          />
        </FlyoutAnchor>
      </div>
    )
  }
}

Search.propTypes = {
  type: PropTypes.string,
  list: PropTypes.array,
  clickHandler: PropTypes.func,
}

export default Search
